import { Box, Link, Typography, useMediaQuery } from "@mui/material";
import { AdditionalInfo } from "components/AdditionalInfo";
import { sharedData } from "helpers/Consts";

export const SectionAdditional = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const message = encodeURIComponent(`Hola IPA, estoy interesado en el paquete *${"Cusco"}*`);
  const whatsappURL = `https://wa.me/${sharedData.tel.replace(" ", "")}?text=${message}`;
  return (
    <Box display="flex" flexDirection="column" marginInline={5} mt={40} mb={30}>
      <Box display="flex" justifyContent="center" flexWrap="wrap" gap={10}>
        <Box display="flex" flexDirection="column" flexWrap="wrap" gap={10}>
          <Typography variant="subtitle2" textTransform="uppercase">
            ¿Que incluye?
          </Typography>
          <AdditionalInfo
            icon="Hotel"
            title="Alojamiento"
            description="03 noches en hotel 2 estrellas (Hotel Ensueño, HP El Paraíso, Hotel Combi, Hotel Sol de Oro)"
          />
          <AdditionalInfo
            icon="Hotel"
            title="Alojamiento"
            description="03 noches en hotel 2 estrellas (Hotel Ensueño, HP El Paraíso, Hotel Combi, Hotel Sol de Oro)"
          />
        </Box>
        <Box display="flex" flexDirection="column" flexWrap="wrap" gap={10}>
          <Typography
            variant="subtitle2"
            textTransform="uppercase"
            textAlign={isMobile ? "center" : "start"}>
            No incluye
          </Typography>
          <AdditionalInfo
            icon="Hotel"
            title="Alojamiento"
            description="03 noches en hotel 2 estrellas (Hotel Ensueño, HP El Paraíso, Hotel Combi, Hotel Sol de Oro)"
          />
          <AdditionalInfo
            icon="Hotel"
            title="Alojamiento"
            description="03 noches en hotel 2 estrellas (Hotel Ensueño, HP El Paraíso, Hotel Combi, Hotel Sol de Oro)"
          />
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" gap={5} mt={15}>
        <Typography variant="subtitle1" textAlign={isMobile ? "center" : "start"}>
          ¡Qué esperas! Solicita esta oferta y vive una nueva aventura
        </Typography>
        <Link
          href={whatsappURL}
          target="_blank"
          textTransform="capitalize"
          aria-label="package"
          underline="none"
          sx={{ "&:hover": { cursor: "pointer" } }}>
          Cotizar en Línea
        </Link>
      </Box>
    </Box>
  );
};
